import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CustomLoader } from './translation/custom-loader';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { AuthInterceptorInterceptor } from './interceptors/auth-interceptor.interceptor';
import { HttpErrorsInterceptor } from './interceptors/http-errors.interceptor';
import { SnackbarService } from './services/snackbar.service';
import { HttpErrorsService } from './services/http-errors.service';
import { HeaderComponent } from './components/header/header/header.component';
import { SharedModule } from '../shared/shared.module';
import { NotificationModalComponent } from './components/header/notification-modal/notification-modal.component';
import { ConfigDropdownComponent } from './components/header/config-dropdown/config-dropdown.component';
import { LocationService } from '../modules/settings/location/services/location.service';
import { OrganizationService } from '../modules/settings/location/services/organization.service';
import { SharedDataService } from '../shared/service/shared-data/shared-data.service';
import { BreadcrumbService } from '../shared/service/breadcrumb.service';
import { AppRoutingModule } from '../app-routing.module';
import { SearchSidebarComponent } from './components/header/search-sidebar/search-sidebar.component';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { TimeoutInterceptor } from './interceptors/timeout.interceptor';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    HeaderComponent,
    NotificationModalComponent,
    ConfigDropdownComponent,
    SearchSidebarComponent,
    NoAccessComponent,
  ],
  imports: [
    HttpClientModule,
    SharedModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomLoader,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    HeaderComponent,
    NotificationModalComponent,
    ConfigDropdownComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    SnackbarService,
    HttpErrorsService,
    LocationService,
    OrganizationService,
    SharedDataService,
    BreadcrumbService,
  ],
})
export class CoreModule {}
